<template>
  <div>
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../../assets/pageloader.svg" class="pageloader" alt="loading">
    </div>
    <div class="row  mt-3 mr-2 ml-lg-2 mt-lg-2 fontsize12 black60 proximanova" v-if="followingList.length>0 && !pageloader">
      <div class="col d-flex ml-4">
        <p class="mb-0">Results Found {{resultCount}}</p>
      </div>
    </div>
    <div class="row no-gutters ml-1 mr-1 mt-2"  v-if="followingList.length>0 && !pageloader">
      <div  v-for="(follower,index) in followingList"  :key="index" class="col-md-6 ">
        <div class="shadow card ml-2 mr-2 mb-2 p-2 pl-3 pr-3 overlay-gradient" v-if="currentRoute == 'selectedCompanyPeople'">
              <!-- <div>
                <video height="280" controlsList="nodownload"  id="profilevideo"  preload="metadata" :ref="'video' + follower.profileId" >
                  <source :src="follower.profileVideo">
                </video>
              </div>
              <div class="card-img-overlay ">
                <div class="row mb-3 ml-0 mr-0 p-lg-3 p-md-3 p-2" :class="{'black_overlay1': follower.profileVideo}"> -->
              <div class="">
                <div class="row d-flex justify-content-between ml-0 mr-0">
                  <div class="pl-0 pr-0 ml-0 d-flex ">
                    <div v-if="!follower.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="follower.firstName.charAt(0)" @click="selectedUser(follower.aliasLink)">
                      <span class="white fontsize16 defmargintop text-uppercase">{{follower.firstName.charAt(0)}}</span>
                    </div>
                    <img v-else :src="follower.profilePictureLink" @click="selectedUser(follower.aliasLink)" alt="profilepic" class="img-fluid rounded-circle hover loadingBgImg" id="profImage">
                  </div>
                  <div class="d-flex flex-column p-1 font12-reg">
                    <div class="my-auto" v-if="follower.followingFlag === 'N' && loggedinUserProfileId != follower.profileId">
                        <div>
                          <button :disabled="follower.disablefollowBtn" @click="follow(follower.profileId,index, follower)" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white">                                         
                            Follow 
                          </button>
                        </div>
                    </div>
                    <div class="my-auto" v-if="follower.followingFlag === 'Y' && loggedinUserProfileId != follower.profileId">
                        <div >
                          <button :disabled="follower.disablefollowBtn" @click="Unfollow_Following(follower.profileId,index, follower)" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white">                                         
                            Following
                          </button>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 p-0 mt-2 d-flex flex-column">
                  <div class="d-flex">
                  <div class="font14bold proximanova-semibold mt-1 text-capitalize hover" id="nameBlock" @click="selectedUser(follower.aliasLink)">{{follower.firstName}} {{follower.lastName}}</div>
                  <div class=""><img src="../../assets/verify_blue.svg" class="my-auto ml-1" alt="verify" width="16px" height="16px" title="Verified" v-if="follower.verifiedProfile == 'SUCCESS'"> </div>
                  </div>
                  <div class="fontsize12 black60 proximanova text-capitalize hover" id="nameBlock" @click="selectedUser(follower.aliasLink)">@{{follower.aliasLink}}</div>
                  <div class="proximanova black60 fontsize12 flex-nowrap text-capitalize mt-1" >
                    <div v-if="follower.designation">{{follower.designation}}</div>                                                
                  </div>
                  <div class="d-flex proximanova black60 fontsize12  text-capitalize flex-wrap">
                    <div v-if="follower.company">{{follower.company}}</div>  
                    <div v-if="follower.city">, {{follower.city}}</div>                                                
                    <div v-if="follower.country">, {{follower.country}}</div>                                              
                  </div>  
                </div>
                <!-- <div class="text-center mt-3" v-if="follower.profileVideo " >
                  <img src="../../assets/play_video.svg" id="playvideobtn" v-if="!follower.isPlaying" alt="playvideo" @click="play_follow('video'+follower.profileId,index, follower)" >
                  <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="follower.isPlaying && follower.replayVideo">
                    <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayfollowerVideo('video'+follower.profileId,index, follower)">
                  </div>
                  <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="follower.isPlaying && follower.loadingVideo">
                    <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="loading">
                  </div>
                  <img src="../../assets/Pausevideo.svg" v-if="follower.isPlaying && !follower.replayVideo && !follower.loadingVideo" :class="{'display-button': follower.isPlaying}" id="playvideobtn" alt="pausevideo" @click="play_follow('video'+follower.profileId,index, follower)">   
                </div>
                <div class="text-center mt-4" v-else>
                  <img src="../../assets/No_profile_video.svg" width="50px" height="50px" title="No profile video" class="" alt="playvideo" >
                </div>
                <div id="bottom">                                                
                  <div class="row d-flex ml-0 mr-0 justify-content-between p-lg-3 p-md-3 p-2 pr-0" :class="{'black_overlay2': follower.profileVideo}">
                    <div class="d-flex flex-wrap badgesection mt-2" v-if="follower.userBadges && follower.userBadges.length>0">
                      <span  v-for="(badge, index) in follower.userBadges" :key="index">
                        <span class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova" :class="{'white borderwhite':follower.profileVideo}" v-if="index < 2">
                          {{badge.badgeIn}}
                        </span>
                        <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova-semibold" :class="{'backgroundcolorwhite borderwhite':follower.profileVideo}" v-if="index > 1 && index == 2" @click="selectedUser(follower.aliasLink)">
                          + {{follower.userBadges.length - 2}}
                        </span>
                      </span>
                    </div>
                    <div class="row col-12 pl-0 pr-0 d-flex ml-0 mr-0 justify-content-between">
                    <div class="d-flex flex-column  mb-2  justify-content-between">
                      <span :class="{'fontsize12 white60 proximanova':follower.profileVideo}"  class="proximanova fontsize12  text-capitalize ml-lg-2 ml-1" v-show="follower.followersProfilePicture && follower.followersProfilePicture.length > 0" >Followers </span>                                                        
                      <div class="row mt-2 ml-0 d-flex ml-2"  >
                        <div  v-for="(item1,index1) in follower.followersProfilePicture" :key="index1">
                          <div v-show="index1 < 6" class="">
                            <img v-if="!item1.profilePictureLink" @click="selectedUser(item1.aliasLink)" id="followImage" class="img-fluid rounded-circle" src="../../assets/Profile_placehlder.svg" alt="profilepic"/>
                            <img v-else :src="item1.profilePictureLink" @click="selectedUser(item1.aliasLink)" class="img-fluid rounded-circle loadingBgImg1" id="followImage" alt="profilepic">
                          </div>
                        </div>
                      </div>   
                    </div>
                    <div class="d-flex flex-column p-1 mt-4 font12-reg">
                      <div :class="{'padding-follow' :follower.followersCount === 0}" v-if="follower.followingFlag === 'N' && loggedinUserProfileId != follower.profileId">
                        <div id="follow">
                          <button :disabled="follower.disablefollowBtn" @click="follow(follower.profileId,index, follower)" :class="{'fontsize16 white60 proximanova-semibold':follower.profileVideo}" class="bordernone backgroundnone fontsize16 black60 proximanova-semibold hover">                                         
                            Follow 
                          </button>
                        </div>
                      </div>
                      <div   v-if="follower.followingFlag === 'Y' && loggedinUserProfileId != follower.profileId">
                        <div >
                          <button :disabled="follower.disablefollowBtn" id="followinguser" @click="Unfollow_Following(follower.profileId,index, follower)" :class="{'fontsize16 white60 proximanova-semibold':follower.profileVideo}" class="bordernone borderradius20 backgroundnone fontsize16 white proximanova-semibold hover">                                         
                            UnFollow 
                          </button>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>     
                </div>                                                 -->
              </div>
            </div>
        <div class="shadow card ml-2 mr-2 mb-2 p-2 pl-3 pr-3 overlay-gradient" v-else>
          <!-- <div>
            <video height="280" controlsList="nodownload"  id="profilevideo" :poster="follower.profileVideoThumbnailLink" :ref="'video' + follower.profileId" >
              <source :src="follower.profileVideoLink">
            </video>
          </div>
          <div class="card-img-overlay ">
            <div class="row mb-3 ml-0 mr-0 p-lg-3 p-md-3 p-2 " :class="{'black_overlay1': follower.profileVideoLink}"> -->
          <div class="">
            <div class="row d-flex justify-content-between ml-0 mr-0">
              <div class="pl-0 pr-0 ml-0 d-flex ">
                <img v-if="follower.profilePictureLink" :src="follower.profilePictureLink" @error="follower.profilePictureLink = null" @click="selectedUser(follower.aliasLink)" alt="profilepic" class="img-fluid rounded-circle hover loadingBgImg" id="profImage">
                <div id="profImage" class=" text-center pointer rounded-circle white" :class="follower.userFirstName.charAt(0)" @click="selectedUser(follower.aliasLink)" v-else>
                  <span class="white fontsize16 text-uppercase">{{follower.userFirstName.charAt(0)}}</span>
                </div>
              </div>
              <div class="d-flex flex-column p-1 font12-reg" >
                  <div class="my-auto" v-if="follower.followingFlag === 'N' && loggedinUserProfileId != follower.profileId">
                    <div>
                      <button  @click="follow(follower.profileId,index, follower)" :disabled="follower.disablefollowBtn" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white">                                         
                          Follow 
                      </button>
                    </div>
                  </div>
                  <div class="my-auto" v-if="follower.followingFlag === 'Y' && loggedinUserProfileId != follower.profileId">
                    <div>
                      <button @click="Unfollow_Following(follower.profileId,index, follower)" :disabled="follower.disablefollowBtn" class="bordernone btn button-create proximanova fontsize13 p-1 pl-3 pr-3 backgroundcolorblack mouseoverbtn2 borderradius20 white"  v-if="follower.followingFlag === 'Y'">                                          
                          Following 
                      </button>
                    </div>
                  </div>
              </div> 
            </div>
            <div class="col-12 p-0 mt-2 d-flex flex-column">
              <div class="d-flex">
              <div class="font14bold proximanova-semibold mt-1 text-capitalize hover" id="nameBlock" @click="selectedUser(follower.aliasLink)">{{follower.userFirstName}} {{follower.userLastname}}</div>
              <div class=""><img src="../../assets/verify_blue.svg" class="my-auto ml-1" alt="verify" width="16px" height="16px" title="Verified" v-if="follower.verifiedProfile == 'SUCCESS'"> </div>
              </div>
              <div class="fontsize12 black60 proximanova text-capitalize hover" id="nameBlock" @click="selectedUser(follower.aliasLink)">@{{follower.aliasLink}}</div>
              <div class=" proximanova black60 fontsize12 flex-nowrap text-capitalize mt-1">
                <div v-if="follower.userRole">{{follower.userRole}}</div>                                                
              </div>
              <div class="d-flex proximanova black60 fontsize12 text-capitalize flex-wrap">
                <div v-if="follower.companyName">{{follower.companyName}}</div>  
                <div v-if="follower.city">, {{follower.city}}</div>                                                
                <div v-if="follower.country">, {{follower.country}}</div>                                              
              </div> 
            </div>
            <!-- <div class="text-center mt-3" v-if="follower.profileVideoLink ">
              <img src="../../assets/play_video.svg" id="playvideobtn" v-if="!follower.isPlaying"  alt="playvideo" @click="play_following('video'+follower.profileId,index, follower)" >
              <div class="replaybtn shadow" title="replay video" id="playvideobtn" v-if="follower.isPlaying && follower.replayVideo">
                <img src="../../assets/replayVideo.png" class="replayicon mx-auto" alt="replayvideo" @click="replayfollowerVideo('video'+follower.profileId,index, follower)">
              </div>
              <div class="replaybtn1 shadow" title="replay video" id="playvideobtn" v-if="follower.isPlaying && follower.loadingVideo">
                <img src="../../assets/video_loading.gif" class="replayicon1 mx-auto" alt="loadingvideo">
              </div>
              <img src="../../assets/Pausevideo.svg" v-if="follower.isPlaying && !follower.replayVideo && !follower.loadingVideo" id="playvideobtn" :class="{'display-button': follower.isPlaying}" alt="pausevideo" @click="play_following('video'+follower.profileId,index, follower)">    
            </div>
            <div class="text-center mt-4 novidstyles" v-if="!follower.profileVideoLink ">
              <img src="../../assets/No_profile_video.svg" width="50px" height="50px" title="No profile video" class="" alt="playvideo" >
            </div>
            <div id="bottom">                                                
              <div class="row d-flex ml-0 mr-0 justify-content-between p-lg-3 p-md-3 p-2 pr-0" :class="{'black_overlay2': follower.profileVideoLink}">
                <div class="d-flex flex-wrap badgesection mt-2" v-if="follower.userBadges && follower.userBadges.length>0">
                  <span  v-for="(badge, index) in follower.userBadges" :key="index">
                    <span class="borderblack60 text-capitalize pl-2 pr-2 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova" :class="{'white borderwhite':follower.profileVideoLink}" v-if="index < 2">
                      {{badge.badgeIn}}
                    </span>
                    <span class="borderblack60 pl-2 pr-2 pointer backgroundcolor5 lineheight p-1 mt-2 mr-2 borderradius20 fontsize10 proximanova-semibold" :class="{'backgroundcolorwhite borderwhite':follower.profileVideoLink}" v-if="index > 1 && index == 2" @click="selectedUser(follower.aliasLink)">
                      + {{follower.userBadges.length - 2}}
                    </span>
                  </span>
                </div>
                <div class="row col-12 pl-0 pr-0 d-flex ml-0 mr-0 justify-content-between">
                <div class="d-flex flex-column  mb-2  justify-content-between">
                  <span :class="{'fontsize12 white60 proximanova':follower.profileVideoLink}"  class="font12-reg proximanova text-capitalize ml-lg-2 ml-1" v-show="follower.followersCount > 0" >Followers </span>                                                        
                  <div class="row mt-2 ml-0 d-flex ml-2">
                    <div  v-for="(item1,index1) in follower.followersProfilePicture" :key="index1">
                      <div v-show="index1 < 6" class="">
                        <img v-if="!item1.profilePictureLink" @click="selectedUser(item1.aliasLink)"  id="followImage" alt="profilepic" class="img-fluid rounded-circle " src="../../assets/Profile_placehlder.svg" />
                        <img v-else :src="item1.profilePictureLink" @click="selectedUser(item1.aliasLink)" alt="profilepic" class="img-fluid rounded-circle loadingBgImg1" id="followImage">                                                                        
                      </div>                                                       
                    </div>
                  </div>                                                           
                </div>
                <div class="d-flex flex-column p-1 mt-4 font12-reg" >
                  <div :class="{'padding-follow' :follower.followersCount === 0}" v-if="follower.followingFlag === 'N' && loggedinUserProfileId != follower.profileId">
                    <div id="follow">
                      <button  @click="follow(follower.profileId,index, follower)" :disabled="follower.disablefollowBtn" :class="{'fontsize16 white60 proximanova-semibold':follower.profileVideoLink}" class="bordernone backgroundnone borderradius20 fontsize16 black60 proximanova-semibold hover">                                         
                          Follow 
                      </button>
                    </div>
                  </div>
                  <div v-if="follower.followingFlag === 'Y' && loggedinUserProfileId != follower.profileId">
                    <div  >
                      <button id="followinguser" @click="Unfollow_Following(follower.profileId,index, follower)" :disabled="follower.disablefollowBtn" :class="{'fontsize16 white60 proximanova-semibold':follower.profileVideoLink}" class="bordernone backgroundnone borderradius20 fontsize16 black60 proximanova-semibold hover"  v-if="follower.followingFlag === 'Y'">                                          
                          UnFollow 
                      </button>
                    </div>
                  </div>
                </div> 
                </div> 
              </div>
            </div>                                                 -->
          </div>
        </div>
      </div>            
    </div>
    <div class="col-12 pb-5 mt-5" v-if="instanceLoader">
      <img src="../../assets/pageloader.svg" class="instanceloader" alt="pageloader">
    </div>
    <div class="row no-gutters ml-3 mr-2 mt-2" v-if="(followingList.length === 0 || instanceFollowingList.length === 0) && !instanceLoader && !pageloader">
      <div  v-for="item in 4"  :key="item" class=" col-6 ">
        <div class="no-record-card mr-2 mb-4 overlay-gradient">
          <div>
            <p>                                            
            </p>
          </div>
        </div>
      </div>
      <img  id="followImage1" class="rounded mx-auto d-block noResult" alt="noresults" src="../../assets/no_results.svg" />
    </div>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal> 
  </div>
</template>
<script>
import httpuserprofile from "@/js/http-userprofile.js";
import httpbusiness from "@/js/http-business.js"
import APIerrorModal from '../APIerrorpopup.vue'
import router from '../../router.js'
import sessionUtils from '@/js/session-util.js'
export default{
  components: {
    APIerrorModal
  },
    data(){
        return{
            currentRoute : null,
            currentUserProfileId: null,
            loggedinUserProfileId : null,
            followingList: [],
            instanceFollowingList : [],
            isScrolled: false,
            pageloader: true,
            instanceLoader : false,
            resultCount: null,
            subFollowers: [],
            //total duration of viewd video
            totalVidSec : null,
            followingLimit : 10,
            followingOffset : 0,
            displayAPIerrorModal : false,
        }
    },
    props : [
      'userProfileDetails'
    ],
    methods:{
      closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
      },
      //play/pause user profile video
        play_following(test,ind, videoItem) {
          var that = this;    
        let index = test.substr(5)   
        if(!this.followingList[ind].isPlaying){
            for(var i=0 ;i <this.followingList.length; i++){
                if(i === ind){                        
                    this.followingList[ind].isPlaying = true;
                    this.$refs[test][0].play();
                }else{
                  if(!this.followingList[i].replayVideo)  {
                    this.$refs['video'+this.followingList[i].profileId][0].pause();     
                    this.followingList[i].isPlaying = false;  
                  }           
                } 
                this.totalVidSec = this.$refs[test][0].duration;
                this.totalVidSec = Math.round(this.totalVidSec)
                this.$refs[test][0].onended = videoEnded;    
                this.$refs[test][0].oncanplay = stopLoadingLogo;  
                this.$refs[test][0].onwaiting = displayLoadingLogo;    
            }
        }else{
            this.followingList[ind].isPlaying = false;
            this.$refs[test][0].pause();
            let percent = this.$refs[test][0].currentTime;
            percent = Math.round(percent)
            this.viewVideo(videoItem, percent) 
        }
        function videoEnded() {
            that.totalVidSec = that.$refs[test][0].duration;
            that.totalVidSec = Math.round(that.totalVidSec)
            that.followingList[ind].isPlaying = true;
            that.followingList[ind].replayVideo = true;
            that.followingList[ind].loadingVideo = false;
            let percent = that.totalVidSec;
            percent = Math.round(percent)
            that.viewVideo(videoItem, percent)
        }
        function stopLoadingLogo() {
          that.totalVidSec = that.$refs[test][0].duration;
          that.totalVidSec = Math.round(that.totalVidSec)
          // console.log("stop loading")
          if(that.followingList[ind].isPlaying){
            that.followingList[ind].loadingVideo = false;
          }
        }
        function displayLoadingLogo() {
          // console.log("start loading")
          if(that.followingList[ind].isPlaying){
            that.followingList[ind].loadingVideo = true;
          }
        } 
    },
    replayfollowerVideo(test,ind, videoItem) {
      // console.log("replay video")
      this.followingList[ind].replayVideo = false;
      this.followingList[ind].isPlaying = false;
      this.play_following(test,ind, videoItem)
    },
    //this will invoke after play/pause to maintain view records to the particular video
    viewVideo(videoItem, viewdsec){
        var fd = new FormData(); 
        var viewvideoId = null;
        if(this.currentRoute == 'selectedCompanyPeople'){
          viewvideoId = videoItem.profile_video_id
        }else{
          viewvideoId = videoItem.profileVideoId
        }
          var obj = {
          profileId : this.loggedinUserProfileId,
          videoId: viewvideoId,
          videoProfileId: videoItem.profileId,
          viewed_sec : viewdsec,
          video_type : 'PROFILEVIDEO'
        }
        console.log("obj : ", obj)
        var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
        fd.append("userVideoViews", blob)
        fd.append("duration", this.totalVidSec)
        httpuserprofile.post("/userprofile/viewVideo", fd, {
          headers: {
              "Content-Type": "multipart/form-data",
            "Accept" : "*/*"
          }
        })
        .then(response => {
          console.log(response)                          
        }) .catch((e) => {
          console.log(e)
        })
    },
    //follow user
    follow(profId,i, follower){
      // if(this.loggedinUserProfileId == this.currentUserProfileId && this.$route.name !== 'selectedCompanyPeople'){ 
        this.isScrolled = true;  
        follower.disablefollowBtn = true;
        httpuserprofile
            .post("/userprofile/saveFollowing?profileId="+this.loggedinUserProfileId+"&followingId="+profId)
            .then(response => {
              this.followingList[i].followingFlag = 'Y';
              follower.disablefollowBtn = false;
            this.getFollowersListFollowers(profId,i);
            this.isScrolled = false;          
        }).catch((e) => {
          console.log(e)
          follower.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        })  
      // }else{
      //   var vm = this;
      //   vm.$toast.info("This functionality is under implementation")
      // }
    },
    //unfollow user
    Unfollow_Following(profId,i, follower){    
      // if(this.loggedinUserProfileId == this.currentUserProfileId && this.$route.name !== 'selectedCompanyPeople'){ 
        this.isScrolled = true;
        follower.disablefollowBtn = true;
        httpuserprofile
            .delete("/userprofile/unfollow?profileId="+this.loggedinUserProfileId+"&followingId="+profId)
            .then(response => {    
              this.followingList[i].followingFlag = 'N';
              follower.disablefollowBtn = false;
              console.log("unfollow user : ", response)       
              // this.resetList()
              this.getFollowersListFollowers(profId,i);
        }).catch((e) => {
          console.log(e)
          follower.disablefollowBtn = false;
          this.displayAPIerrorModal = true;
        })  
      // }else{
      //   var vm = this;
      //   vm.$toast.info("This functionality is under implementation")
      // }
    },
    //get updated list after unfollowing any user
    resetList(){
      this.pageloader = true;
      this.followingOffset = 0;  
      this.instanceFollowingList = [];
      this.followingList = [];   
      this.getFollowingList();
    },
    //fetching the followers list after follow/unfollow to update particular user followers list
    getFollowersListFollowers(profId,index){         
        httpuserprofile
        .get("/userprofile/getFollowerUserList?profileId="+profId+'&loginUserProfileId='+this.loggedinUserProfileId+'&loginUserType=user&limit=4&offset=0')
        .then(response => {            
           if(response.data.length)   {
                this.subFollowers = response.data;
                if(this.subFollowers.length > 0){
                    if(this.followingList[index].followersProfilePicture){
                        this.followingList[index].followersProfilePicture = [];
                        this.followingList[index].followersProfilePicture = this.subFollowers;
                        this.followingList[index].followersCount = this.subFollowers.length;
                    }
                  }
                // for(var i = 0; i < this.subFollowers.length; i++){ 
                //     if(!this.followingList[index].followersProfilePicture){
                //         this.followingList[index].followersProfilePicture = [];
                //     }     
                //     // this.followingList[index].followingFlag = 'Y';            
                //     if(this.loggedinUserProfileId === this.subFollowers[i].profileId){               
                //      //   this.followingList[index].followingFlag = 'Y'; 
                //         let followerObj = {
                //             profilePictureLink : this.subFollowers[i].profilePictureLink,
                //             profileId: this.loggedinUserProfileId
                //         }   
                //         this.followingList[index].followersProfilePicture.push(followerObj);                        
                //         this.followingList[index].followersCount = this.followingList[index].followersCount+1;                        
                //         return;
                //     }else{               
                //         for(var j= 0 ; j< this.followingList[index].followersProfilePicture.length; j++){                        
                //         if(this.loggedinUserProfileId === this.followingList[index].followersProfilePicture[j].profileId){
                //             this.followingList[index].followersProfilePicture.splice(j,1)
                //         }
                //     }             
                //     //this.followingList[index].followingFlag = 'N';
                //     }            
                // }
           }else{            
                this.followingList[index].followersProfilePicture = [];
                this.followingList[index].followersCount = 0;
                // this.followingList[index].followingFlag = 'N';
           }      
        });
    },   
    // this will invoke after click on username/profile picture
    // Navigate to seperate page where user can able to see the selected user information
    selectedUser(id){         
        this.$store.state.selectedUser = id;    
        // if(sessionUtils.getUserId() === id){
        //   router.push({
        //     name : 'welcome'
        //   })
        // }else{
          this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
        // }     
        //this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
    },
    //fetching following users list
    getFollowingList(){   
      this.instanceFollowingList = []   
        httpuserprofile
            .get("/userprofile/getFollowingUserList?profileId="+this.currentUserProfileId+'&loginUserProfileId='+this.loggedinUserProfileId+'&loginUserType=user&limit='+this.followingLimit+'&offset='+this.followingOffset)
            .then(response => {         
              console.log("get user following : ", response)   
                this.pageloader  = false;
                this.isScrolled = false;
                this.instanceLoader = false;
                // this.resultCount = response.data.length;  
                if(response.data.length > 0){
                  this.resultCount = response.data[0].totalrecordsfound;
                }
                response.data.forEach(function(d){
                    d.isPlaying = false;
                    d.replayVideo = false;
                    d.loadingVideo = false;
                    d.disablefollowBtn = false; 
                })  
                this.instanceFollowingList = response.data;
                this.followingList = this.followingList.concat(this.instanceFollowingList)
        }).catch((e) => {
          console.log(e)
          this.pageloader = false;
          this.instanceLoader = false;
        });;       
    },
    getSelectedCompanyFollowingList(){
          this.instanceFollowingList = [];
        httpbusiness
        .get('/business/getFollowingForLoggedInCompany?companyProfileId='+this.currentUserProfileId+'&loginUserProfileId='+this.loggedinUserProfileId+'&loginUserType=user&limit='+this.followingLimit+'&offset='+this.followingOffset)
        .then(response => {   
          console.log("following company response : ", response)      
            if(response.data){ 
                this.pageloader = false;
                this.isScrolled = false;
                this.instanceLoader = false;
                // this.resultCount = response.data.length; 
                if(response.data && response.data.list && response.data.list.length > 0){
                  this.resultCount = response.data.totalrecordsfound;
                }
                if(response.data.list){
                response.data.list.forEach(function(d){ 
                   d.isPlaying = false;    
                  d.replayVideo = false;
                  d.loadingVideo = false;
                  d.disablefollowBtn = false;             
                }) 
                this.instanceFollowingList = response.data.list;
                this.followingList = this.followingList.concat(this.instanceFollowingList) 
                }                       
            }          
        }).catch((e) => {
          console.log(e)
          this.pageloader = false;
          this.instanceLoader = false;
        });
    }, 
    //this will invoke while scrolling down to fetch more records
    handleScrollFollowing () {       
        if(!this.isScrolled && this.instanceFollowingList.length >= 9){          
            if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) ) {     
                this.isScrolled = true;    
                this.instanceLoader = true;
                this.followingOffset = this.followingOffset+10; 
                if(this.$route.name == 'selectedCompanyPeople'){
                 this.getSelectedCompanyFollowingList()
                }else{
                this.getFollowingList(); 
                }
            }        
        }    
      },
    },
    mounted(){
      console.log("following : ", this.userProfileDetails)
      this.loggedinUserProfileId = sessionUtils.getUserProfileId()
      this.currentRoute = this.$route.name;
      if(this.$route.name == 'selectedCompanyPeople'){
        if(this.userProfileDetails){
          this.currentUserProfileId = this.userProfileDetails.companyProfileId
        }
        this.getSelectedCompanyFollowingList()
      }else{
      if(this.$route.name == 'selectedUserPeople'){
        if(this.userProfileDetails){
          this.currentUserProfileId = this.userProfileDetails.profileId
        }
      }else{
        this.currentUserProfileId = sessionUtils.getUserProfileId();
      }
        this.getFollowingList();
      }
        window.addEventListener('scroll', this.handleScrollFollowing);
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.handleScrollFollowing)
    }
}
</script>
<style scoped>


.footer {
  position: fixed;
  bottom: 0;
}
.pageloader {
  width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
.instanceloader{
  width: 7%;
  margin-left: 46%;
}
.loadingBgImg{
  background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.loadingBgImg1{
    background: transparent url('../../assets/loading_gif1.gif') center no-repeat;
  background-size: 20px 20px;
}
.list-group-item{
  padding: .25rem 0.25rem;
  border: none;
}
.modal-footer{
  background-color: #ffffff
}
.font12-bold_filter{
  font-size: 14px;
  font-weight: bold;
  color: #1F1F1F;
}
.font12-bold{
  font-size: 14px;
  font-weight: bold;
  color: #1F1F1F;
}
.closebtnmouseover {
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    border: 1px solid white;
}
.closebtnmouseover:hover {
  /* margin-top: -4px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  padding-left: 6px;
  padding-right: 3px; */
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}

.profilestrength {
  margin-left: 0px !important;
}
.line1 {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.no-record-card{
  background-color: #A1A6B3 !important;
  opacity: 6%;
  height: 15rem;
  border-radius: 10px;
}
.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}
.navtoPage {
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  padding-left : 5px;
  padding-top: 2px;
  cursor: pointer;  
}
.navtoPage::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius: 20px;
  background-color :  rgba(29, 27, 27, 0.1);
}
.navtoPage:hover:before {
  cursor: pointer;
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}
.font12-60opacity{
  font-size: 12px;
  color: rgba(31,31,31,.6);
  font-family: 'Proxima Nova Regular';
}
.text-color{
  color: #0078ff;
  font-size: 12px;
}
.button-create-font {
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: bold;
}
.input-group-append{
  margin-left: 0  !important;
}
.badge{
  transform: scale(1.6) !important;
  width: 23px;
  padding-top: 6px;
  height: 23px;
  font-size: 50%;
}
.badge-success {
  color: #fff;
  background-color:black;
}
.badge-fill {
  padding-right: .6em;
  padding-left: 0.8em;
  border-radius: 10rem;
}
#filterDropdown{
  left : 57%;
  z-index: 3;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 360%;
}
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}

#followinguser{
  transition : 0.5s all ease;
  position : relative;
  background-color: #007AFF !important;        
  border-radius: 4px;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  padding-left: 10px !important;
  z-index : 1;
  text-align: right;
}
#followinguser::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 50%;
  right : 50%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
#followinguser:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  padding-bottom: 5px;    
  padding-right: 10px !important;
  padding-top: 5px !important;
  border-radius:20px;
}
#followinguser{
  margin-left:5px;
  color: #FFF !important;
  cursor: pointer;
}
.searchtext{
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
#nameBlock:hover{
  color:#007AFF !important;
}
#profilevideo{
  width: 100%;
  border-radius: 4%;
  object-fit: fill;
}
.card-padding{
  padding-right: 0px !important;
}
.vbottom{
  position: relative;
  top: 100%;
  transform: translateY(-100%); 
}
a:hover{
    color: white !important;
}

.no-record-card{
  background-color: #A1A6B3 !important;
  opacity: 6%;
  height: 15rem;
  border-radius: 10px;
}
.top-margin{
  margin-top: -300px !important;
  margin-left: auto;	
  margin-right: auto;	
  display: block;
}
.font12-reg{
  font-family: 'Proxima Nova Regular';
  font-size: 12px;
}
.max-height{
  height: 15rem;
}
.dropdown-menu{
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.right-align{
  margin-right: 10px;;
}
.card-img-overlay {
  padding: 0 !important;
}
.black_overlay1 {
  background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%);
  border-radius: 4px 4px 5px 4px;
}
.black_overlay2 {
  background: linear-gradient(180deg, rgba(0,0,0,0) 10%, #000000 100%);
  border-radius: 0 4px 5px 4px;
}
.card-img-overlay:hover #playvideobtn{
  display: block;
}
#playvideobtn {
  display: block;
  margin-left: 45%;
  margin-top: 12%;
  margin-bottom: 5%;
  cursor: pointer;
}
.card-img-overlay:hover #playvideobtn{
  display: block !important;
}
.display-button{
  display: none !important;
}
.no-image{
  margin-bottom: 5%;
}
.footer {
  position: fixed;
  bottom: 0;
}
.modal-content{
  border-radius: 10px  !important;
}
.modal-height{
  height: auto;
  margin-top: 5% !important;
  width: 100% !important;
  border-radius: 10px !important;
}
.text-design{
  background-color: #A1A6B3;
 /* opacity: 10%; */
  color: black;    
}
#bottom {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
.modal-body{
  background-color: #000000
}
.header {
  position: fixed;
  width: 100%;
  z-index: 10;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.header__content-text {
  text-align: center;
  padding: 15px 20px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
}
.footer{
  z-index: 5;
}
.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
}
.nav{ 
  background-color: #f0f2f5  !important; 
  border-radius: 8px !important;
}
.video-player{
  border-radius: 20px; 
  overflow: hidden; 
}
.welcomename {
  font-size: 14px !important;
}
.dot {
  height: 45px;
  width: 45px;
  background-color: #1F1F1F;
  border-radius: 50%;
  display: inline-block;
}
.btn-color{
  border-color: #1F1F1F;
}
.navbar {
  padding: 0px 0px 0px 0px !important;
  z-index: 100;
}
.nav{
  flex-wrap: unset !important;
}
.padding-follow{
    padding-bottom:  0.5rem;
}
.list-text-color {
  color: #0078ff;
  font-weight: bold;
  letter-spacing: 0;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.check-with-label:checked + .label-for-check {
  font-weight: bold;
}
.text-color1{
  color: #FFFFFF !important;
  font-size: 14px  !important;
}
.text-color2{
  color: #FFFFFF !important;
  font-size: 12px  !important;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
#profImage{
  width: 45px;
  height: 45px;
  border:1px solid #ced4da;
  line-height: 45px;
}
#profImage:hover{
  border: 1px solid #007AFF;
}
.hover {
  cursor: pointer;
}
.video{ 
  width: 100%;
}
#follow{
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1;
  text-align: right;
  /* right:2%; */
  padding-left : 5px;
  padding-top: 2px;
  padding-right: 5px;
  padding-bottom: 2px;
}
#follow::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 10%;
  bottom : 0;
  opacity : 0;
  content : "";
  border-radius:20px;
  background-color :  rgba(31,31,31,.3);
}
#follow:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  padding-left:5px;
  opacity : 1;
  z-index : -1;
  border-radius:20px;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
#followImage1{
  width: 30px;
  height: 30px;  
}
.form-control:focus{
  outline: none !important;
  box-shadow: none !important;   
  border-radius: 10px;
  background-color: rgba(161, 166, 179,0.1);
  border: #DDDFE5;
}
input:focus,
textarea:focus {
  outline: none; /** For Safari, etc **/
  border: transparent;
}
.bigger-font{
  font-weight: bold;
}
.noResult{
  zoom: 6;
  margin-left: 5px;
  margin-top: -60px;
}
.padding{
  padding: 5px !important;
}
.padding-top{
  position: absolute;
  right: 2%;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-img-top {
  object-fit: cover;
}
@media only screen and (max-width: 539px) {
    .pageloader {
        width: 20%;
        margin-top: 25%;
    }
    .padding-top{
        padding-top: 0.8rem;
        font-size:10px
    }
    #followinguser{
        margin-left: 0%;
    }
    #followinguser{
        font-size: 12px;
    }
    #follow a{
        font-size: 8px;
        /* padding-bottom: 1rem !important; */
    }    
    .font12-reg{
        font-size: 8px !important;
    }
    .topmenubar {
        margin-left: 1.5em;
    }
    /* #profImage{
        width: 24px;
        height: 24px;
        line-height: 19px;
    }  
    #profImage > span {
      font-size: 12px !important;
    }  */
    .loadingBgImg{
        background-size: 20px 20px;
    }
    .loadingBgImg1{
        background-size: 15px 15px;
    }
}
@media screen and (min-width: 300px) and (max-width: 350px) {    
    #playvideobtn {
        margin-left: 40%;
        margin-top: 25%;
    }
    #filterDropdown{
        left : 47%;
    }
    #playvideobtn {
        margin-left: 40%;
    }
}
@media screen and (min-width: 350px) and (max-width: 400px) {
#filterDropdown{
 left : 47% 
}
#playvideobtn {
  margin-left: 40%;
  margin-top: 35%;
}
nav ul li a {
    display: block;
    padding: 0.5rem 0.5rem !important;
    color: grey;
    text-decoration: none;
    display: block;
    flex: 0 1 auto;
    list-style-type: none;
    /* background: #fafafa; */
    font-size: 10px;
    max-width: 200px;
}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}

@media screen and (min-width: 300px) and (max-width: 400px) {
    nav ul li a{
        padding: 0.5rem 0.5rem;
    }
    #followImage{
        width: 15px;
        height: 15px;
        transform: scale(1.6)  !important;
        /* border: 1px solid black; */
    }
    .font16-bold{
        font-size: 8px  !important;
    }
}
@media screen and (min-width: 400px) and (max-width: 500px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 40%;
        margin-top: 30%;
    }
    #followImage{
        width: 18px;
        height: 18px;
    }
}
@media only screen and (max-width: 600px) {
    .font12-60opacity{
        font-size: 10px !important;
    }
    .fontsize12{
        font-size: 13px !important;
    }
    .text-color2{
        font-size: 10px !important;
    }
    .font16-bold{
        font-size: 12px;
    }
    .sign-in-button{
        font-size: 12px;
    }
    .pageloader {
        width: 20%;
        margin-top: 25%;
    }
    .padding-top{
        padding-top: 0.8rem;
        /* font-size:10px */
    }
    #following{
        margin-left: 0%;
    }
    #following a{
        font-size: 8px;
    }
    #follow a{
        font-size: 8px;
        /* padding-bottom: 1rem !important; */
    }
    .font12-bold{
        font-size: 10px  !important;
    }    
    .font12-reg{
        font-size: 8px !important;
    }   
    .topmenubar {
        margin-left: 1.5em;
    }
}
@media screen and (min-width: 500px) and (max-width: 600px) {
    #filterDropdown{
        left : 47% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 25%;
    }
}
@media screen and (max-width: 900px) and (min-width: 600px) {
    #filterDropdown{
        left : 55% 
    }
    #playvideobtn {
        margin-left: 40%;
    }
}
@media screen and (max-width: 900px) and (min-width: 800px) {
    #filterDropdown{
        left : 55% 
    }
    #playvideobtn {
        margin-left: 45%;
        margin-top: 15%;
    }
}
@media screen and (min-width: 900px) and (max-width: 1100px) {
    #playvideobtn {
        margin-left: 35% !important;
    }
}
@media screen and (min-width: 900px) and (max-width: 1295px) {   
   #filterDropdown{
        left : 55% 
    }  
}
</style>

